// src/components/workout/DeleteWorkoutDialog.jsx
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Trash2 } from "lucide-react";

/**
 * Confirmation dialog for deleting a workout from history
 */
const DeleteWorkoutDialog = ({ 
  open, 
  onOpenChange,
  workoutToDelete, 
  onConfirmDelete, 
  isDeleting 
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Trash2 className="h-5 w-5 text-destructive" />
            Delete Workout
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to delete this workout? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        
        <DialogFooter className="mt-4">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={() => onConfirmDelete(workoutToDelete)}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete Workout'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteWorkoutDialog;